import { Expose, Type } from "class-transformer";
import { OptionModel } from "../option";
export interface OpeningHoursData {
  isClosed: boolean;
  isOrderBeer: boolean;
  isOrderAlcohol: boolean;
  isOrderNonAlcohol: boolean;
  opening: string;
  closing: string;
  startOrder: string;
  stopOrder: string;
}

export interface CustomerOpeningHours {
  mon: OpeningHoursData;
  tue: OpeningHoursData;
  wed: OpeningHoursData;
  thu: OpeningHoursData;
  fri: OpeningHoursData;
  sat: OpeningHoursData;
  sun: OpeningHoursData;
}

export class BudgetModel {
  constructor() {
    this.spend = 0;
    this.allocate = 0;
  }

  @Expose({ name: "spend" })
  spend: number;

  @Expose({ name: "allocate" })
  allocate: number;
}

export class AchievementModel {
  constructor() {
    this.output = 0;
    this.goal = 0;
  }

  @Expose({ name: "aggregateOutput" })
  output: number;

  @Expose({ name: "aggregateGoal" })
  goal: number;
}

export class TotalSaleTargetModel {
  constructor() {
    this.coordinator = "";
    this.product = [];
  }

  @Expose({ name: "activitycoordinator" })
  coordinator: string;

  @Expose({ name: "product" })
  product?: [];
}

export class ActivityHistoryModel {
  constructor() {
    this.image = "";
    this.date = "";
    this.name = "";
    this.budget = undefined;
    this.achievement = undefined;
    this.totalsalestarget = undefined;
  }

  @Expose({ name: "surveyPic" })
  image: string | any;

  @Expose({ name: "surveyDate" })
  date: string | any;

  @Expose({ name: "activityName" })
  name: string | any;

  @Type(() => BudgetModel)
  @Expose({ name: "budget" })
  budget?: BudgetModel;

  @Type(() => AchievementModel)
  @Expose({ name: "achievement" })
  achievement?: AchievementModel;

  @Type(() => TotalSaleTargetModel)
  @Expose({ name: "totalsalestarget" })
  totalsalestarget?: TotalSaleTargetModel;
}

export class ActivityNextModel {
  constructor() {
    this.image = "";
    this.date = "";
    this.name = "";
    this.budget = undefined;
    this.achievement = undefined;
    this.totalsalestarget = undefined;
  }

  @Expose({ name: "surveyPic" })
  image: string | any;

  @Expose({ name: "monthEventMap" })
  date: string;

  @Expose({ name: "activityName" })
  name: string;

  @Type(() => BudgetModel)
  @Expose({ name: "budget" })
  budget?: BudgetModel;

  @Type(() => AchievementModel)
  @Expose({ name: "achievement" })
  achievement?: AchievementModel;

  @Type(() => TotalSaleTargetModel)
  @Expose({ name: "totalsalestarget" })
  totalsalestarget?: TotalSaleTargetModel;
}

export class FrequencyModel {
  constructor() {
    this.amount = 0;
    this.month = "";
    this.sequence = 0;
  }

  @Expose({ name: "frequency" })
  amount: number;

  @Expose({ name: "monthName" })
  month: string;

  sequence: number;
}

export class HistoryModel {
  constructor() {
    this.date = "";
    this.visitPlanStatus = "";
    this.sequence = 0;
    this.detail = "";
  }

  sequence: number;
  visitPlanStatus: string;

  @Expose({ name: "visitPlanDate" })
  date: string;

  @Expose({ name: "visitPlanDetail" })
  detail: string;

  get status() {
    let value = 0;
    if (this.visitPlanStatus == "COMPLETE") {
      value = 1;
    } else if (this.visitPlanStatus == "NEVER") {
      value = 2;
    } else if (this.visitPlanStatus == "NEXT") {
      value = 3;
    } else if (this.visitPlanStatus == "INCOMPLETE") {
      value = 4;
    }

    return value;
  }

  get statusText() {
    let value = "";
    if (this.visitPlanStatus == "COMPLETE") {
      value = "เยี่ยมสำเร็จ";
    } else if (this.visitPlanStatus == "NEVER") {
      value = "ไม่มีการเข้าเยี่ยมในวันนี้";
    } else if (this.visitPlanStatus == "NEXT") {
      value = "แผนครั้งถัดไป";
    } else if (this.visitPlanStatus == "INCOMPLETE") {
      value = "เยี่ยมไม่สำเร็จ";
    } else {
      value = "ยังไม่ถึงรอบ";
    }
    return value;
  }
}

export class ManagerModel {
  constructor() {
    this.contactId = 0;
    this.saleOrgCriteriaId = 0;
    this.saleOrgCriteriaName = "";
    this.titleName = "";
    this.firstName = "";
    this.lastName = "";
    this.phone = "";
    this.email = "";
    this.date = "";
    this.isCurrent = false;
    this.image = undefined;
  }

  contactId: number;
  saleOrgCriteriaId: number;
  saleOrgCriteriaName: string;
  titleName: string;
  firstName: string;
  lastName: string;
  email: string;

  @Expose({ name: "mobileNo" })
  phone: string;

  @Expose({ name: "lastEffectiveDate" })
  date: string;

  @Expose({ name: "currentFlag" })
  isCurrent: boolean;

  @Expose({ name: "imagePath" })
  image?: string | null;

  get name() {
    return this.titleName + this.firstName + " " + this.lastName;
  }
}

export class SaleManagerByCustomerModel {
  constructor() {
    this.month = undefined;
    this.frequency = undefined;
    this.manager = [];
    this.history = [];
  }

  @Type(() => OptionModel)
  @Expose({ name: "viewMonthFilter" })
  month?: OptionModel[];

  @Type(() => FrequencyModel)
  @Expose({ name: "visitPlanFrequency" })
  frequency?: FrequencyModel[];

  @Type(() => ManagerModel)
  @Expose({ name: "saleManagerHistory" })
  manager?: ManagerModel[];

  @Type(() => HistoryModel)
  @Expose({ name: "visitPlanDateHistory" })
  history?: HistoryModel[];
}

export class SaleManageerBySurveyHistoryModel {
  constructor() {
    this.date = new Date();
    this.name = "";
  }

  @Expose({ name: "surveyDate" })
  date: Date;

  @Expose({ name: "surveyName" })
  name: string;
}

export class CustomerModel {
  constructor() {
    this.id = 0;
    this.prefix = "";
    this.name = "";
    this.code = "";
    this.owner = "";
    this.phone = "";
    this.latitude = 0;
    this.longitude = 0;
    this.image = "";
    this.note = "";
    this.address = "";
    this.salesOrg = "";
    this.isDisableCheckIn = true;
    this.eActivityList = [];
    this.customerPlanId = 0;
    this.planID = undefined;
    this.routePlanId = undefined;
    this.customerLocationData = undefined;
    this.managerName = "";
    this.subManagerName = "";
    this.sellerName = "";
    this.mobile = "";
    this.customerTierListData = [];
    this.latestemployeevisit = undefined;
    this.isEnableClosedReport = false;
    this.isEnableNoContactRequest = false;
    this.customerBillAddress = "";
    this.customerShipToAddress = "";
    this.salesOrgs = [];
    this.isExclusiveShop = false;
    this.locationType = "";
    this.customerCredit = undefined;
    this.ablZone = [];
    this.customerOpeningHours = undefined;
    this.isAllowCheckInForSaleAndDistribution = false;
    this.customerUUid = "";
  }

  @Expose({ name: "customerId" })
  id: number | string;

  @Expose({ name: "customerPrefix" })
  prefix: string;

  @Expose({ name: "customerName" })
  name: string;

  @Expose({ name: "customerCode" })
  code: string;

  @Expose({ name: "ownerName" })
  owner: string;

  @Expose({ name: "ownerMobileNo" })
  mobile: string;

  @Expose({ name: "customerTel" })
  phone?: string;

  @Expose({ name: "customerAddress" })
  address: string;

  @Expose({ name: "latitude" })
  latitude?: number | string | null;

  @Expose({ name: "longitude" })
  longitude?: number | string | null;

  @Expose({ name: "customerLocationData" })
  customerLocationData: any;

  @Expose({ name: "customerTierListData" })
  customerTierListData: any;

  @Expose({ name: "customerPicName" })
  image: string;

  @Expose({ name: "note" })
  note: string | null;

  @Expose({ name: "salesOrg" })
  salesOrg: string;

  @Expose({ name: "isDisableCheckIn" })
  isDisableCheckIn: boolean;

  eActivityList: [];

  @Expose({ name: "customerPlanId" })
  customerPlanId: number | string | null;

  @Expose({ name: "planID" })
  planID?: number | string | null;

  @Expose({ name: "routePlanId" })
  routePlanId?: number | string | null;

  @Expose({ name: "manager" })
  managerName: string;

  @Expose({ name: "assistantmanager" })
  subManagerName: string;

  @Expose({ name: "saleman" })
  sellerName: string;

  @Expose({ name: "latestemployeevisit" })
  latestemployeevisit: any;

  @Expose({ name: "isEnableClosedReport" })
  isEnableClosedReport: boolean;

  @Expose({ name: "isEnableNoContactRequest" })
  isEnableNoContactRequest: boolean;

  @Expose({ name: "customerBillAddress" })
  customerBillAddress: string;

  @Expose({ name: "customerShipAddress" })
  customerShipToAddress: string;

  @Type(() => SalesOrgItemModel)
  @Expose({ name: "salesOrgs" })
  salesOrgs: SalesOrgItemModel[];

  @Expose({ name: "isExclusiveShop" })
  isExclusiveShop: boolean;

  @Expose({ name: "locationType" })
  locationType: string;

  @Type(() => CustomerCreditModel)
  @Expose({ name: "customerCredit" })
  customerCredit?: CustomerCreditModel;

  @Expose({ name: "ablZone" })
  ablZone: string[];

  @Expose({ name: "customerOpeningHours" })
  customerOpeningHours?: CustomerOpeningHours;

  isAllowCheckInForSaleAndDistribution: boolean;

  customerUUid: string;

  get visitorName() {
    if (this.latestemployeevisit) {
      return this.latestemployeevisit?.empName;
    } else {
      return undefined;
    }
  }

  get visitDate() {
    if (this.latestemployeevisit) {
      return this.latestemployeevisit?.visitDate;
    } else {
      return undefined;
    }
  }

  get tier() {
    let lst = new Array();
    this.customerTierListData?.map((item: any) => {
      lst.push(item.shopAttribute);
    });
    return lst.join(", ");
  }

  get abl() {
    return this.ablZone && this.ablZone.length > 0
      ? this.ablZone.join(", ")
      : "-";
  }

  get eActivities() {
    return this.eActivityList && this.eActivityList.length > 0
      ? this.eActivityList.join(", ")
      : "";
  }
}

export class H2HModel {
  constructor() {
    this.companyBrand = "";
    this.companyColorCode = "";
    this.otherBrand = "";
    this.otherColorCode = "";
    this.percentOfBrand = "";
  }

  @Expose({ name: "companyBrand" })
  companyBrand: string;

  @Expose({ name: "companyColorCode" })
  companyColorCode: string;

  @Expose({ name: "otherBrand" })
  otherBrand: string;

  @Expose({ name: "otherColorCode" })
  otherColorCode: string;

  @Expose({ name: "percentOfBrand" })
  percentOfBrand: string;
}

export class FilterModel {
  constructor() {
    this.text = "";
    this.value = 0;
    this.color = "";
    this.default = false;
  }

  @Expose({ name: "filterText" })
  text: string;

  @Expose({ name: "filterValue" })
  value: number;

  @Expose({ name: "filterColor" })
  color: string;

  @Expose({ name: "isDefault" })
  default: boolean;
}

export class MapCustomerModel {
  constructor() {
    this.id = 0;
    this.code = "";
    this.name = "";
    this.latitude = 0;
    this.longitude = 0;
    this.type = 0;
    this.address = "";
  }

  @Expose({ name: "customerId" })
  id: number;

  @Expose({ name: "customerCode" })
  code: string;

  @Expose({ name: "customerName" })
  name: string;

  @Expose({ name: "latitude" })
  latitude: number;

  @Expose({ name: "longitude" })
  longitude: number;

  @Expose({ name: "type" })
  type: number;

  @Expose({ name: "address" })
  address: string;
}

export class SalesOrgItemModel {
  constructor() {
    this.salesOrg = "";
    this.salesOrgCriteria = "";
  }
  @Expose({ name: "salesOrg" })
  salesOrg: string;

  @Expose({ name: "salesOrgCriteria" })
  salesOrgCriteria: string;
}

export class CustomerCreditModel {
  constructor() {
    // this.creditLimit = "0";
    // this.useCredit = "0";
    this.customerCreditsId = 0;
    this.creditLimit = 0;
    this.remainingCredit = 0;
    this.creditTotal = 0;
    this.usedCredit = 0;
    this.outstandingAmount = 0;
    this.overdueCount = 0;
    this.paymentDate = 0;
    this.isBlocked = false;
    this.creditTermCode = null;
    this.creditTermShortName = null;

  }

@Expose ({name : "customerCreditsId" })
customerCreditsId: number

@Expose ({name : "creditLimit" })
creditLimit: number

@Expose ({name : "remainingCredit" })
remainingCredit: number

@Expose ({name : "creditTotal" })
creditTotal: number

@Expose ({name : "usedCredit" })
usedCredit: number

@Expose ({name : "outstandingAmount" })
outstandingAmount: number

@Expose ({name : "overdueCount" })
overdueCount: number

@Expose ({name : "paymentDate" })
paymentDate: number

@Expose ({name : "isBlocked" })
isBlocked: boolean

@Expose ({name : "creditTermCode" })
creditTermCode: string | null

@Expose ({name : "creditTermShortName" })
creditTermShortName: string | null


  // @Expose({ name: "creditLimit" })
  // creditLimit: string;

  // @Expose({ name: "useCredit" })
  // useCredit: string;
}
